import { LanguageCode } from '../enums';

export const LANGS: LanguageCode[] = [LanguageCode.UK, LanguageCode.PL, LanguageCode.EN, LanguageCode.SK];
